import { z } from 'zod';

export const missingClipChallengeSchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  type: z.string(),
  triageStatus: z.string(),
});

export const getMissingClipsResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(missingClipChallengeSchema),
});

export type IMissingClipChallenge = z.infer<typeof missingClipChallengeSchema>;
export type IGetMissingClipsResponse = z.infer<typeof getMissingClipsResponseSchema>;
